export default __webpack_public_path__ + "images/3T.27b6cba.png";